import PropTypes from 'prop-types'

export default PropTypes.shape({
  provider_incentive_cost_id: PropTypes.number.isRequired,
  start_date:                 PropTypes.string.date,
  end_date:                   PropTypes.string.date,
  state_code:                 PropTypes.string.isRequired,
  amount:                     PropTypes.number.isRequired
});
